/**
 * Configuration de transmission par catégorie — SafeHeir
 *
 * Source de vérité unique pour : mode de transmission, délai de
 * déclenchement, libellé par catégorie de coffre.
 *
 * Référence : T-S4-ATTR-02 — Spec V2 §3
 *            (docs/03-specs/SafeHeir_Spec_Attribution_Acces_MVP++_V2.md)
 * Modèle de données : docs/02-security/attribution-data-model.md
 *
 * Mapping arbitré 2026-05-29 par Shadows (CEO) + CTO :
 *   - admin → mode info, J+15 (services publics français : Ameli,
 *     impôts, CAF, retraite, etc. — information patrimoniale à
 *     transmettre au notaire, pas accès direct)
 *   - crypto absente du coffre actuel — non incluse ici
 *
 * Labels alignés sur AccountCategoryPicker.js (duplication assumée
 * temporairement — à factoriser dans src/config/categories.js
 * post-S8 ou T-S4-ATTR-XX).
 *
 * Consommateurs prévus :
 *   - T-S4-ATTR-03 : beneficiaryService (validation valeurs)
 *   - T-S4-ATTR-04 : composant attribution (UX wording deux niveaux)
 *   - T-S4-ATTR-05 : récap Dashboard "En cas de transmission…"
 *
 * RÉSERVE JURIDIQUE : les wordings et la mention de prudence doivent
 * être validés par un avocat en droit des successions et un DPO avant
 * go-live (cf T-S5-00). MVP++ ne revendique aucune certification.
 */

export const TRANSMISSION_CONFIG = {
  admin:         { mode: 'info',    delay: 'J+15', label: 'Administratif & légal'      },
  finance:       { mode: 'info',    delay: 'J+15', label: 'Finance'                    },
  pro:           { mode: 'info',    delay: 'J+15', label: 'Pro & business'             },
  security:      { mode: 'info',    delay: 'J+7',  label: 'Sécurité & accès'    },
  storage:       { mode: 'direct',  delay: 'J+30', label: 'Stockage & données'    },
  communication: { mode: 'limited', delay: 'J+30', label: 'Communication'              },
  social:        { mode: 'direct',  delay: 'J+30', label: 'Réseaux sociaux'       },
  ecommerce:     { mode: 'direct',  delay: 'J+30', label: 'E-commerce & abonnements'   },
  gaming:        { mode: 'direct',  delay: 'J+30', label: 'Gaming & loisirs'           },
  misc:          { mode: 'direct',  delay: 'J+30', label: 'Divers'                     },
};

export const MODE_WORDING = {
  info:    'sera informé·e — à transmettre au notaire si nécessaire',
  direct:  'pourra accéder à cette catégorie',
  keys:    'recevra les moyens de récupération',
  limited: 'gestion limitée — selon les conditions du service',
};

export const PRUDENCE_NOTICE =
  "L'accès ou la transmission effectifs dépendent des conditions de chaque " +
  "service et du cadre légal applicable. SafeHeir prépare et transmet vos " +
  "instructions ; il n'autorise pas juridiquement l'accès et ne se substitue " +
  "ni au notaire ni à la banque. Les héritiers et le notaire restent seuls " +
  "compétents pour les suites successorales.";

export const DASHBOARD_DISCLAIMER =
  "SafeHeir organise et transmet vos instructions. SafeHeir n'est ni notaire, " +
  "ni banque, et ne se substitue pas aux procédures successorales ou bancaires.";
